export default [
    {
        name: 'quote_id',
        localizationSlug: 'QUOTE_ID',
        editable: true,
    },
    {
        name: 'delivery_order',
        localizationSlug: 'DELIVERY_ORDER',
        editable: true,
    },
    {
        name: 'equipment_id',
        localizationSlug: 'EQUIPMENT_ID',
        editable: false,
    },
    {
        name: 'gate_dropoff',
        localizationSlug: 'GATE_DROPOFF',
        editable: true,
    },
    {
        name: 'gate_pickup',
        localizationSlug: 'GATE_PICKUP',
        editable: true,
    },
    {
        name: 'house_bill_number',
        localizationSlug: 'HOUSE_BILL_NUMBER',
        editable: true,
    },
    {
        name: 'invoice_number',
        localizationSlug: 'INVOICE_NUMBER',
        editable: false,
    },
    {
        name: 'isa',
        localizationSlug: 'ISA',
        editable: true,
    },
    {
        name: 'master_bol',
        localizationSlug: 'MASTER_BOL',
        editable: true,
    },
    {
        name: 'mg_load_id',
        localizationSlug: 'MG_LOAD_ID',
        editable: true,
    },
    {
        name: 'mo_number',
        localizationSlug: 'MO_NUMBER',
        editable: true,
    },
    {
        name: 'order_id',
        localizationSlug: 'ORDER_ID',
        editable: false,
    },
    {
        name: 'payout_number',
        localizationSlug: 'PAYOUT_NUMBER',
        editable: false,
    },
    {
        name: 'po_number',
        localizationSlug: 'PO_NUMBER',
        editable: true,
    },
    {
        name: 'pu_number',
        localizationSlug: 'PU_NUMBER',
        editable: true,
    },
    {
        name: 'scac_code',
        localizationSlug: 'SCAC_CODE',
        editable: false,
    },
    {
        name: 'seal_number',
        localizationSlug: 'SEAL_NUMBER',
        editable: true,
    },
    {
        name: 'shipment_id',
        localizationSlug: 'SHIPMENT_ID',
        editable: false,
    },
    {
        name: 'tracking_id',
        localizationSlug: 'TRACKING_ID',
        editable: true,
    },
    {
        name: 'truck_order',
        localizationSlug: 'TRUCK_ORDER',
        editable: true,
    },
    {
        name: 'VRID',
        localizationSlug: 'VRID',
        editable: true,
    },
    {
        name: 'work_order_number',
        localizationSlug: 'WORK_ORDER_NUMBER',
        editable: true,
    },
    // [CARGO-8982] Kinne Specific Reference Number Types Are Below
    {
        name: 'last_move',
        localizationSlug: 'LAST_MOVE',
        editable: true,
    },
    {
        name: 'final_destination',
        localizationSlug: 'FINAL_DESTINATION',
        editable: true,
    },
    {
        name: 'cargo_weight',
        localizationSlug: 'CARGO_WEIGHT',
        editable: true,
    },
    {
        name: 't_state',
        localizationSlug: 'T_STATE',
        editable: true,
    },
    {
        name: 'position',
        localizationSlug: 'POSITION',
        editable: true,
    },
    {
        name: 'freight_kind',
        localizationSlug: 'FREIGHT_KIND',
        editable: true,
    },
    {
        name: 'over_weight',
        localizationSlug: 'OVER_WEIGHT',
        editable: true,
    },
    {
        name: 'reqs_power',
        localizationSlug: 'REQS_POWER',
        editable: true,
    },
    {
        name: 'unit_impediments',
        localizationSlug: 'UNIT_IMPEDIMENTS',
        editable: true,
    },
    {
        name: 'booking_number',
        localizationSlug: 'BOOKING_NUMBER',
        editable: true,
    },
    {
        name: 'trinium_order_id',
        localizationSlug: 'TRINIUM_ORDER_ID',
        editable: false,
    },
];
